'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _themeCart = require('@shopify/theme-cart');

var shopifyCart = _interopRequireWildcard(_themeCart);

var _types = require('./types');

var pushCartTypes = _interopRequireWildcard(_types);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (_ref) {
  var _actions, _getters;

  var action = _ref.action,
      maxQuantity = _ref.maxQuantity,
      submitTo = _ref.submitTo,
      translations = _ref.translations,
      delivery = _ref.delivery,
      grapheneHC = _ref.grapheneHC,
      discount = _ref.discount,
      promoted = _ref.promoted,
      gifts = _ref.gifts;

  var state = {
    initialData: {
      action: action,
      maxQuantity: maxQuantity,
      submitTo: submitTo,
      translations: translations,
      delivery: delivery,
      grapheneHC: grapheneHC,
      discount: discount,
      promoted: promoted
    },
    loading: false,
    lineItems: [],
    subtotal: null,
    maxQuantity: 15,
    itemCount: null,
    giftProducts: gifts.products,
    giftThreshold: gifts.threshold,
    giftMaxGifts: gifts.maxGifts,
    giftDiscountRate: gifts.discountRate,
    giftInitiallyOpen: gifts.initiallyOpen
  };

  var actions = (_actions = {}, (0, _defineProperty3.default)(_actions, pushCartTypes.ACTION__ADD_ITEM_TO_CART, function () {
    var _ref4 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(_ref2, _ref3) {
      var commit = _ref2.commit,
          state = _ref2.state;
      var id = _ref3.id,
          properties = _ref3.properties,
          quantity = _ref3.quantity;
      var data, itemsUpdatedEvent;
      return _regenerator2.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              state.loading = true;

              _context.next = 3;
              return shopifyCart.addItem(id, { properties: properties, quantity: quantity });

            case 3:
              _context.next = 5;
              return shopifyCart.getState();

            case 5:
              data = _context.sent;


              commit(pushCartTypes.MUTATION__UPDATE_LINE_ITEMS, data);

              state.loading = false;

              itemsUpdatedEvent = new CustomEvent('itemsUpdated');

              document.dispatchEvent(itemsUpdatedEvent);

            case 10:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    return function (_x, _x2) {
      return _ref4.apply(this, arguments);
    };
  }()), (0, _defineProperty3.default)(_actions, pushCartTypes.ACTION__REMOVE_ALL_ITEMS, function () {
    var _ref6 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(_ref5) {
      var commit = _ref5.commit,
          state = _ref5.state;
      var itemsUpdatedEvent;
      return _regenerator2.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              state.loading = true;

              _context2.t0 = commit;
              _context2.t1 = pushCartTypes.MUTATION__UPDATE_LINE_ITEMS;
              _context2.next = 5;
              return shopifyCart.clearItems();

            case 5:
              _context2.t2 = _context2.sent;
              (0, _context2.t0)(_context2.t1, _context2.t2);


              state.loading = false;

              itemsUpdatedEvent = new CustomEvent('itemsUpdated');

              document.dispatchEvent(itemsUpdatedEvent);

            case 10:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    return function (_x3) {
      return _ref6.apply(this, arguments);
    };
  }()), (0, _defineProperty3.default)(_actions, pushCartTypes.ACTION__REMOVE_ITEM, function () {
    var _ref9 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(_ref7, _ref8) {
      var commit = _ref7.commit;
      var key = _ref8.key;
      var cart, lineItem, linkedItem, itemsUpdatedEvent;
      return _regenerator2.default.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              state.loading = true;

              _context3.next = 3;
              return shopifyCart.getState();

            case 3:
              cart = _context3.sent;
              lineItem = cart.items.find(function (cartItem) {
                return cartItem.key === key;
              });

              if (!('__Child uid' in lineItem.properties)) {
                _context3.next = 10;
                break;
              }

              linkedItem = cart.items.find(function (cartItem) {
                return cartItem.properties['__Parent uid'] === lineItem.properties['__Child uid'];
              });

              if (!linkedItem) {
                _context3.next = 10;
                break;
              }

              _context3.next = 10;
              return shopifyCart.removeItem(linkedItem.key);

            case 10:
              _context3.prev = 10;
              _context3.next = 13;
              return shopifyCart.removeItem(key);

            case 13:
              _context3.next = 18;
              break;

            case 15:
              _context3.prev = 15;
              _context3.t0 = _context3['catch'](10);

              if (_context3.t0.message === 'Theme Cart: Unable to match line item with provided key') {
                window.location.reload();
              } else {
                itemsUpdatedEvent = new CustomEvent('itemsUpdated');

                document.dispatchEvent(itemsUpdatedEvent);
              }

            case 18:
              _context3.t1 = commit;
              _context3.t2 = pushCartTypes.MUTATION__UPDATE_LINE_ITEMS;
              _context3.next = 22;
              return shopifyCart.getState();

            case 22:
              _context3.t3 = _context3.sent;
              (0, _context3.t1)(_context3.t2, _context3.t3);


              state.loading = false;

            case 25:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, this, [[10, 15]]);
    }));

    return function (_x4, _x5) {
      return _ref9.apply(this, arguments);
    };
  }()), (0, _defineProperty3.default)(_actions, pushCartTypes.ACTION__UPDATE_QUANTITY_OF_ITEM, function () {
    var _ref12 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4(_ref10, _ref11) {
      var commit = _ref10.commit;
      var key = _ref11.key,
          quantity = _ref11.quantity;
      var itemsUpdatedEvent;
      return _regenerator2.default.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              state.loading = true;
              _context4.t0 = commit;
              _context4.t1 = pushCartTypes.MUTATION__UPDATE_LINE_ITEMS;
              _context4.next = 5;
              return shopifyCart.updateItem(key, { quantity: quantity });

            case 5:
              _context4.t2 = _context4.sent;
              (0, _context4.t0)(_context4.t1, _context4.t2);


              state.loading = false;

              itemsUpdatedEvent = new CustomEvent('itemsUpdated');

              document.dispatchEvent(itemsUpdatedEvent);

            case 10:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, this);
    }));

    return function (_x6, _x7) {
      return _ref12.apply(this, arguments);
    };
  }()), (0, _defineProperty3.default)(_actions, pushCartTypes.ACTION__UPDATE_QUANTITY_OF_MULTIPLE_ITEMS, function () {
    var _ref15 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee6(_ref13, _ref14) {
      var commit = _ref13.commit;

      var processItems = function () {
        var _ref16 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee5() {
          var items = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
          var item, cartState;
          return _regenerator2.default.wrap(function _callee5$(_context5) {
            while (1) {
              switch (_context5.prev = _context5.next) {
                case 0:
                  if (!(items.length === 0)) {
                    _context5.next = 2;
                    break;
                  }

                  return _context5.abrupt('return');

                case 2:
                  item = items.shift();
                  _context5.next = 5;
                  return shopifyCart.updateItem(item.key, {
                    quantity: item.quantity
                  });

                case 5:
                  cartState = _context5.sent;

                  if (!(items.length === 0)) {
                    _context5.next = 8;
                    break;
                  }

                  return _context5.abrupt('return', cartState);

                case 8:
                  return _context5.abrupt('return', processItems(items));

                case 9:
                case 'end':
                  return _context5.stop();
              }
            }
          }, _callee5, this);
        }));

        return function processItems() {
          return _ref16.apply(this, arguments);
        };
      }();

      var data = _ref14.data;
      var itemsUpdatedEvent;
      return _regenerator2.default.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              state.loading = true;

              _context6.t0 = commit;
              _context6.t1 = pushCartTypes.MUTATION__UPDATE_LINE_ITEMS;
              _context6.next = 5;
              return processItems(data);

            case 5:
              _context6.t2 = _context6.sent;
              (0, _context6.t0)(_context6.t1, _context6.t2);


              state.loading = false;

              itemsUpdatedEvent = new CustomEvent('itemsUpdated');

              document.dispatchEvent(itemsUpdatedEvent);

            case 10:
            case 'end':
              return _context6.stop();
          }
        }
      }, _callee6, this);
    }));

    return function (_x8, _x9) {
      return _ref15.apply(this, arguments);
    };
  }()), _actions);

  var mutations = (0, _defineProperty3.default)({}, pushCartTypes.MUTATION__UPDATE_LINE_ITEMS, function (state, _ref17) {
    var lineItems = _ref17.items,
        subtotal = _ref17.total_price,
        itemCount = _ref17.item_count;

    state.lineItems = lineItems;
    state.subtotal = subtotal;
    state.itemCount = itemCount;
  });

  var getters = (_getters = {}, (0, _defineProperty3.default)(_getters, pushCartTypes.GET_INITIAL_DATA, function (state) {
    return state.initialData;
  }), (0, _defineProperty3.default)(_getters, pushCartTypes.GET_ITEM_COUNT, function (state) {
    return state.itemCount;
  }), (0, _defineProperty3.default)(_getters, pushCartTypes.GET_LINE_ITEMS, function (state) {
    return state.lineItems;
  }), (0, _defineProperty3.default)(_getters, pushCartTypes.GET_LOADING, function (state) {
    return state.loading;
  }), (0, _defineProperty3.default)(_getters, pushCartTypes.GET_SUBTOTAL, function (state) {
    return state.subtotal;
  }), (0, _defineProperty3.default)(_getters, pushCartTypes.GET_GIFT_PRODUCTS, function (state) {
    return state.giftProducts;
  }), (0, _defineProperty3.default)(_getters, pushCartTypes.GET_GIFT_THRESHOLD, function (state) {
    return state.giftThreshold;
  }), (0, _defineProperty3.default)(_getters, pushCartTypes.GET_GIFT_MAX_GIFTS, function (state) {
    return state.giftMaxGifts;
  }), (0, _defineProperty3.default)(_getters, pushCartTypes.GET_GIFT_DISCOUNT_RATE, function (state) {
    return state.giftDiscountRate;
  }), (0, _defineProperty3.default)(_getters, pushCartTypes.GET_GIFT_INITIALLY_OPEN, function (state) {
    return state.giftInitiallyOpen;
  }), _getters);

  return {
    state: state,
    actions: actions,
    mutations: mutations,
    getters: getters
  };
};